import { connect } from 'react-redux';
import { createSession } from '../redux/actions/createSession';
import Welcome from '../components/welcome/Welcome';

const mapDispatchToProps = dispatch => ({
  createSession: () => dispatch(createSession()),
});

export default connect(null, mapDispatchToProps)(Welcome);
